import { useForm } from '../../../../../shared/form/useForm';
import { IResetPasswordFormData } from '../../../domain/models/IResetPasswordFormData';
import { useResetPasswordSchema } from '../../../domain/models/ResetPasswordSchema';

export function useResetPasswordForm() {
	const validationSchema = useResetPasswordSchema();
	const form = useForm<IResetPasswordFormData>({
		mode: 'onSubmit',
		validationSchema,
		defaultValues: {},
	});

	return form;
}
